import axios from "axios"
import { I18n } from 'react-redux-i18n'

import {defaultConfig} from "../config"
import {getHeaders} from "../helpers/urlHelper"

//User login action
export function setHomePreference(preference) {
  return function(dispatch) {
    dispatch({type: "USER_SET_HOMEPREFERENCE", payload: preference})

    axios.post(defaultConfig.url + "/settings/homepreference",
      {
        "preference":preference
      },
      {
        headers: getHeaders()
      })
      .then((response) => {
        //Set logged in to true
        dispatch({type: "USER_SET_HOMEPREFERENCE_FULFILLED"})

        // Show success snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'success',
          message: I18n.t('settings.homepref_changed'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 1600
        }})
      })
      .catch((err) => {
        dispatch({type: "USER_SET_HOMEPREFERENCE_REJECTED", payload: err})

        // Show error snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'error',
          message: I18n.t('global.server_error'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 5000
        }})
      })
  }
}



// WEBPACK FOOTER //
// ./src/js/actions/settingsActions.js